import { render, staticRenderFns } from "./SettingsLocalisationCountriesAllowedList.vue?vue&type=template&id=3822ba61&"
import script from "./SettingsLocalisationCountriesAllowedList.vue?vue&type=script&lang=ts&"
export * from "./SettingsLocalisationCountriesAllowedList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports